/*
A tiny pure function that, given CurrentUserResponse, tells the FE where to navigate.
We’ll start with something conservative that matches how you were routing before:
PATIENT:
accountPhase = BASIC_ACCOUNT → patient “Create Account” / complete profile page
accountPhase = COMPLETED_PROFILE → main patient experience (your /ProviderSearchPage)

PROVIDER:
Route to /ProviderProfile (you can later introduce a provider accountPhase if you want)
ADMIN:
/AdminTabs
*/

/**
 * Decide which route to go to based on the /me response.
 *
 * @param {object|null} currentUser CurrentUserResponse from backend (or null if not logged in)
 * @returns {string|null} A React Router path string or null if no redirect is needed.
 */
export function resolveRouteForCurrentUser(currentUser) {
  if (!currentUser) return null;

  const { userType, providerId } = currentUser;

  switch (userType) {
    case "PATIENT":
      return null;

    case "PROVIDER": {
      // Provider without a linked DB record (e.g. unclaimed / new)
      // → send to search page so they can find & re-claim their NPI profile
      if (providerId == null) {
        return "/ProviderSearchPage";
      }

      if (currentUser.providerVerificationStatus !== "VERIFIED") {
        return "/ProviderVerificationPending";
      }

      // ✅ Completed and verified provider (provider record exists)
      return "/ProviderProfile";
    }

    case "ADMIN": {
      return "/admin";
    }

    default:
      return null;
  }
}
